import { Row, Col, Form, Checkbox, Input, Radio } from "antd";
import { forwardRef, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import { update_mdexpenselist_form } from "../../actions/form_slice";
import { debounce } from "lodash";

const MDEXPENSELIST = forwardRef(({ onValuesChange }, ref) => {
  const [form] = Form.useForm();

  useImperativeHandle(ref, () => ({
    getFieldsError: form.getFieldsError,
    validateFields: form.validateFields,
    resetFields: form.resetFields,
    setFieldsValue: form.setFieldsValue,
    submit: form.submit,
    getFieldsValue: form.getFieldsValue,
  }));

  const dispatch = useDispatch();
  const formData = useSelector((state) => state.form.mdexpenselist_form_type);

  const handleFormChange = debounce((changedValues) => {
    dispatch(update_mdexpenselist_form(changedValues));
    onValuesChange(formData);
  }, 300);
  return (
    <Form
      form={form}
      onValuesChange={handleFormChange}
      // onFinish={props.onFinish}
      labelAlign="justify"
      layout="horizontal"
      labelWrap
      wrapperCol={{
        flex: 1,
      }}
    >
      <Form.Item
        name="Are you OR a member of your household:"
        label="Are you OR a member of your household:"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Checkbox.Group>
          <Checkbox value="Disabled">Disabled</Checkbox>
          <Checkbox value="60 or Older">60 or Older</Checkbox>
        </Checkbox.Group>
      </Form.Item>
      <Form.Item
        name="Do you have medical expenses?"
        label="Do you have medical expenses?"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Checkbox.Group>
          <Checkbox value="One-time expense">One-time expense</Checkbox>
          <Checkbox value="Ongoing expense over $35/ month">
            Ongoing expense over $35/ month
          </Checkbox>
        </Checkbox.Group>
      </Form.Item>
      <Row>
        <label>*Check KMMS for Spenddown if applicable*</label>
      </Row>
      <Form.Item
        name="Does anyone help you pay any of these expenses?"
        label="Does anyone help you pay any of these expenses?"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Radio.Group>
          <Radio value="yes">Yes</Radio>
          <Radio value="no">No</Radio>
        </Radio.Group>
      </Form.Item>

      <Row gutter={4}>
        <Col span={12}>
          <Form.Item name="Comments" label="Comments">
            <Input style={{ width: "100%" }} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="Pending for" label="Pending for:">
            <Input style={{ width: "100%" }} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
});
export default MDEXPENSELIST;
